import { render, staticRenderFns } from "./UCurriculars.vue?vue&type=template&id=02df5206&scoped=true&"
import script from "./UCurriculars.vue?vue&type=script&lang=js&"
export * from "./UCurriculars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02df5206",
  null
  
)

export default component.exports